import { render, staticRenderFns } from "./app.vue?vue&type=template&id=264d6efa&scoped=true&"
import script from "./app.ts?vue&type=script&lang=ts&"
export * from "./app.ts?vue&type=script&lang=ts&"
import style0 from "./app.scss?vue&type=style&index=0&id=264d6efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264d6efa",
  null
  
)

component.options.__file = "app.vue"
export default component.exports